import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import store, { showLightbox } from '../../state';
// import CloseIcon from '../../components/header/burger/close-icon';
// import ProgressImage from '../../components/progress-image';
import './lightbox.css';

function closeLightbox(e) {
  e.preventDefault();
  store.dispatch(showLightbox(null));
}

const Lightbox = ({ image }) => {
  if (!image) return null;

  return (
    <div className="lightbox">
      <div className="close">
        <a href="#close" onClick={closeLightbox}>
          {/* <CloseIcon /> */}
        </a>
      </div>
      <div className="lightbox-inner">
        {/* <ProgressImage image={image} /> */}
        <img src={image.sizes.full.src} alt={image.alt} />
      </div>
    </div>
  );
};

Lightbox.propTypes = {
  image: PropTypes.object,
};

Lightbox.defaultProps = {
  image: null,
};

const mapStateToProps = state => ({
  image: state.get('lightbox'),
});

export default connect(mapStateToProps)(Lightbox);



// WEBPACK FOOTER //
// ./src/components/lightbox/index.jsx